import { render } from "./Analizator.vue?vue&type=template&id=63fda608&scoped=true"
import script from "./Analizator.vue?vue&type=script&lang=js"
export * from "./Analizator.vue?vue&type=script&lang=js"

import "./Analizator.vue?vue&type=style&index=0&id=63fda608&scoped=true&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fda608"]])

export default __exports__